export enum SOCKET_DRAWER_EVENT {
  /**
   * Recieves an event when a drawer is added
   */
  added = 'drawer:added',
  /**
   * Recieves an event when a drawer is removed
   */
  removed = 'drawer:removed'
}
